(() => {
  if (window.__bcPerformance) return;

  const state = {
    interactions: [],
    longTasks: [],
    tags: [],
    worstInteraction: null,
  };
  const reportedInteractions = new Set();
  const SLOW_INTERACTION_THRESHOLD = 200;

  const describeTarget = (target) => {
    if (!(target instanceof Element)) return 'unknown';
    const stable = target.closest('[data-testid], [data-bc-app-intent], [id], button, a, input, select, textarea');
    if (!stable) return target.tagName.toLowerCase();
    if (stable.dataset.testid) return `[data-testid="${stable.dataset.testid}"]`;
    if (stable.dataset.bcAppIntent) return `[data-bc-app-intent="${stable.dataset.bcAppIntent}"]`;
    if (stable.id) return `#${CSS.escape(stable.id)}`;
    const name = stable.getAttribute('aria-label') || stable.textContent?.trim().replace(/\s+/g, ' ').slice(0, 60);
    return `${stable.tagName.toLowerCase()}${name ? `:${name}` : ''}`;
  };

  const recordInteraction = (entry) => {
    if (!entry.interactionId) return;
    const interaction = {
      interactionId: entry.interactionId,
      duration: Math.round(entry.duration),
      inputDelay: Math.max(0, Math.round(entry.processingStart - entry.startTime)),
      processing: Math.max(0, Math.round(entry.processingEnd - entry.processingStart)),
      presentationDelay: Math.max(0, Math.round(entry.startTime + entry.duration - entry.processingEnd)),
      name: entry.name,
      target: describeTarget(entry.target),
      startTime: Math.round(entry.startTime),
    };

    state.interactions.push(interaction);
    state.interactions.sort((a, b) => b.duration - a.duration);
    state.interactions = state.interactions.slice(0, 20);
    state.worstInteraction = state.interactions[0] || null;
    window.dispatchEvent(new CustomEvent('bc:cwv-interaction', { detail: interaction }));

    if (state.worstInteraction === interaction) reportSlowInteraction(interaction);
  };

  const reportSlowInteraction = (interaction) => {
    if (interaction.duration < SLOW_INTERACTION_THRESHOLD) return;
    if (reportedInteractions.has(interaction.interactionId)) return;
    reportedInteractions.add(interaction.interactionId);

    const payload = {
      event: 'bc_cwv_slow_interaction',
      bc_cwv_metric: 'INP',
      bc_cwv_value: interaction.duration,
      bc_cwv_input_delay: interaction.inputDelay,
      bc_cwv_processing: interaction.processing,
      bc_cwv_presentation_delay: interaction.presentationDelay,
      bc_cwv_event_name: interaction.name,
      bc_cwv_target: interaction.target,
      bc_cwv_path: window.location.pathname,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('bc:cwv-report', { detail: payload }));
  };

  try {
    new PerformanceObserver((list) => list.getEntries().forEach(recordInteraction)).observe({
      type: 'event',
      buffered: true,
      durationThreshold: 40,
    });
  } catch (_error) {
    // Event Timing is not available in every browser.
  }

  try {
    new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        state.longTasks.push({ duration: Math.round(entry.duration), startTime: Math.round(entry.startTime) });
      }
      state.longTasks.sort((a, b) => b.duration - a.duration);
      state.longTasks = state.longTasks.slice(0, 20);
    }).observe({ type: 'longtask', buffered: true });
  } catch (_error) {
    // Long Tasks is not available in every browser.
  }

  window.addEventListener('load', () => {
    window.setTimeout(() => {
      state.tags = Array.from(document.scripts)
        .map((script) => script.src)
        .filter((src) => /googletagmanager\.com|google-analytics\.com/i.test(src))
        .map((src) => {
          try {
            const url = new URL(src);
            return { host: url.host, id: url.searchParams.get('id') || '', src };
          } catch (_error) {
            return { host: '', id: '', src };
          }
        });
    }, 0);
  }, { once: true });

  window.__bcPerformance = state;
})();
